import { parsePhoneNumber } from "libphonenumber-js";
import { byDial } from "./countries";

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

// optional field: empty is fine, otherwise it must look like a web address
export const isWebsite = (v) => !v || /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+(\/.*)?$/.test(String(v).trim());

export const isPhone = (dial, number) => {
  const digits = String(number || "").replace(/\D/g, "");
  if (!digits) return false;
  try {
    const p = parsePhoneNumber(`${dial}${digits}`);
    if (p?.isValid()) return true;
  } catch {
    /* fall through to the length check */
  }
  const c = byDial(dial);
  if (c) return digits.length === c.local;
  return digits.length >= 6 && digits.length <= 14; // a country that is not in the list
};

/** 0..4 plus a label. Only length is enforced (8+); the meter just nudges towards a better one. */
export const passwordStrength = (pw) => {
  const s = String(pw || "");
  if (!s) return { score: 0, label: "" };
  let score = 0;
  if (s.length >= 8) score += 1;
  if (s.length >= 12) score += 1;
  if (/[a-z]/.test(s) && /[A-Z]/.test(s)) score += 1;
  if (/\d/.test(s) && /[^A-Za-z0-9]/.test(s)) score += 1;
  if (s.length < 8) return { score: 1, label: "Too short" };
  return { score: Math.max(score, 1), label: ["", "Weak", "Fair", "Good", "Strong"][Math.max(score, 1)] };
};
